module.exports = __webpack_public_path__ + "img/11400.2084ad81.jpg";